"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function axisPropsFromTickScale(scale, tickCount) {
    const range = scale.range();
    const values = scale.ticks(tickCount);
    const format = scale.tickFormat(tickCount);
    const position = scale.copy();
    return {
        range,
        values,
        format,
        position,
    };
}
exports.default = axisPropsFromTickScale;
//# sourceMappingURL=axisPropsFromTickScale.js.map